import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=688f67ac&"
import script from "./ProductSlider.vue?vue&type=script&lang=js&"
export * from "./ProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./ProductSlider.vue?vue&type=style&index=0&id=688f67ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports